






































































import { Mixins, Component } from 'vue-property-decorator';
import Table from '@/components/Table/Index.vue';
import { getModule } from 'vuex-module-decorators';
import GameModule from '@/store/modules/Game';
import ErrorHandleMixin from '@/mixins/ErrorHandle.vue';

@Component({
  components: {
    Table,
  },
})
export default class RtpManagement extends Mixins(ErrorHandleMixin) {
  TableHead = [
    [
      {
        text: 'No',
      },
      {
        text: 'Game name',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'RTP Coin',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'RTP',
        attr: {
          class: 'text-left',
        },
      },
      {
        text: 'Manage',
        attr: {
          class: 'text-left',
        },
      },
    ],
  ];

  GameInstance = getModule(GameModule, this.$store);

  data = [];

  rtpModal = false;

  statusMaintenance = '';

  url = '';

  rtp = 0;

  rtpCoin = 0;

  prefix = '';

  typeList: string [] = [];

  type = 'all';

  created() {
    this.fetchGame();
  }

  async fetchGame() {
    this.GeneralInstance.toggleLoading(true);
    const res = await this.GameInstance.FetchGameRtpList();
    if (res.code) {
      this.checkError(res);
    } else {
      const games = res.games.filter((v) => v.partner === 'AMBSLOT');
      games.forEach((element) => {
        // eslint-disable-next-line no-param-reassign
        element.cs = this.convertRtp(element.cs);
        if (!this.typeList.includes(element.type)) this.typeList = [...this.typeList, element.type];
      });
      games.sort((a, b) => b.cs - a.cs);
      if (this.type !== 'all') {
        this.data = games.filter((v) => v.type === this.type);
      } else {
        this.data = games;
      }
    }
    this.GeneralInstance.toggleLoading(false);
  }

  editRtp(val) {
    this.prefix = val.prefix;
    this.rtp = val.cs;
    this.rtpCoin = val.ac;
    this.rtpModal = true;
  }

  async handleRtp(rtp, rtpCoin) {
    // if (typeof rtp === 'number' && rtp && typeof rtpCoin === 'number' && rtpCoin) {
    if (typeof rtp === 'number' && rtp) {
      this.GeneralInstance.toggleLoading(true);
      const res = await this.GameInstance.EditUpdateRtp({ rtp, rtpCoin, prefix: this.prefix });
      if (res.code === 0) {
        this.checkError(res);
      } else {
        this.errorHandle(res.code, res);
      }
      this.rtpModal = false;
      this.fetchGame();
      this.GeneralInstance.toggleLoading(false);
    } else {
      this.errorHandle(999, 'Invalid Type');
      this.rtpModal = false;
    }
  }

  errorHandle(code, message) {
    this.GeneralInstance.ShowAlert({
      isAlert: true,
      alertMsg: message,
      alertColor: code === 0 ? 'success' : 'danger',
    });
  }

  handleChange() {
    this.fetchGame();
  }

  convertRtp(rtp) {
    return rtp;
  }
}
